<template>
    <div class="col col-12 pa-0 input-form">
        <span class="label">
            <b v-if="field.title">{{field.title_not_to_trad ? field.title : $t(field.title)}}</b>
            <b v-else style="color: transparent;">AAA</b>
            <span v-if="field.props && field.props.required" style="color:red">&nbsp;*</span>
            <infoTooltip v-if="field.tooltip" :tooltip="field.tooltip" />
        </span>

        <v-text-field :label="field.title ? $t(field.title) : ''" v-model="model[fieldName]" v-bind="props" :rules=[validate]>
            <template v-slot:append>
                <v-menu v-model="menu" top nudge-bottom="105" nudge-left="16" :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                        <div :style="swatchStyle" v-on="on" />
                    </template>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-color-picker v-model="model[fieldName]" flat />
                        </v-card-text>
                    </v-card>
                </v-menu>
            </template>
        </v-text-field>
    </div>
</template>

<script>
import validate from '../functions/validations'
import infoTooltip from '@/components/infoTooltip';

export default {
    props: ["model", "fieldName", "field"],
    components: { infoTooltip },
    mixins: [validate],
    data() {
        return {
            menu: false,
        };
    },
    computed: {
        props() {
            if(this.field.props && this.field.props.placeholder && !this.field.props.placeholderAlreadyTranslated) {
                this.field.props.placeholderAlreadyTranslated = true;
                this.field.props.placeholder = this.$t(this.field.props.placeholder);
            }
            return this.field.props;
        },
        swatchStyle() {
            return {
                backgroundColor: this.model[this.fieldName],
                cursor: 'pointer',
                height: '30px',
                width: '30px',
                borderRadius: this.menu ? '50%' : '4px',
                transition: 'border-radius 200ms ease-in-out'
            }
        }
    }
};
</script>

<style lang="scss">
.input-form {
    .v-input__slot {
        background-color: var(--v-lightgrey-base) !important;
    }
}
</style>